import classNames from 'classnames';

import { usePermissions, useAuthContext, useModal } from '/src/hooks';

import { Button, Tooltip } from '@crazyegginc/hatch';
import { UpsellModal } from '/src/features/addons/common/modals/UpsellModal';

import { FEATURES } from '/src/features/_global/constants';
import { MANAGE_SUBSCRIPTION_PATH } from '/src/features/_global/constants';

import { ReactComponent as ReloadIcon } from '@crazyegginc/hatch/dist/images/icon-redo.svg';
import { ReactComponent as UpsellIcon } from '@crazyegginc/hatch/dist/images/icon-crown-filled.svg';
import { ReactComponent as DownloadIcon } from '@crazyegginc/hatch/dist/images/icon-arrow-download.svg';

export function CommonActions({ survey, refresh, className }) {
  const { token } = useAuthContext();
  const permissions = usePermissions();
  const modal = useModal();
  const canExportCsv = permissions.can('csv', FEATURES.EXPORT).allowed;

  const disabled = survey.responseCount === 0;

  return (
    <div className={classNames('flex items-center space-x-2.5', className)}>
      <Button
        leftIcon={<ReloadIcon className="h-4 w-4 fill-current mr-2" aria-label="refresh survey result" />}
        variant="secondary"
        onClick={refresh}
        size="lg"
      >
        Refresh
      </Button>

      {!canExportCsv ? (
        <Tooltip
          placement="top"
          style={{ padding: '0px' }}
          tooltipContent={
            <div className="w-[352px] text-left px-4 pb-2.5 pt-2">
              <p className="text-sm font-semibold mb-0.5">Export CSV of Summary Results</p>
              <p className="leading-tight">This feature is available with a Starter plan or above.</p>
              <p className="leading-tight">Click this button to learn more.</p>
            </div>
          }
        >
          <Button
            variant="secondary"
            size="lg"
            leftIcon={<DownloadIcon className="h-4 w-4 fill-current mr-2" aria-label="download survey csv" />}
            rightIcon={
              <UpsellIcon className="text-[#fbbd33] h-4 w-4 fill-current ml-2" aria-label="upsell export csv" />
            }
            onClick={() => modal.show(<UpsellModal link={MANAGE_SUBSCRIPTION_PATH} metricType="addon_download_csv" />)}
          >
            Export CSV
          </Button>
        </Tooltip>
      ) : (
        <Button
          leftIcon={<DownloadIcon className="h-4 w-4 fill-current mr-2" aria-label="download survey csv" />}
          component={!disabled ? 'a' : undefined}
          variant="secondary"
          {...(!disabled && {
            href: `${window.CORE_API_URL}/export/survey.csv?site_id=${survey.siteId}&survey_id=${survey.id}&token=${token}`,
            download: true,
          })}
          disabled={disabled}
          size="lg"
        >
          Export CSV
        </Button>
      )}
    </div>
  );
}
